import { ReactNode } from "react";
import { Container } from "react-bootstrap";

import { Lot } from '../../Types/Lot';
import { LotDetailProvider } from '../../Contexts/LotDetailContext';
import { LotDetailsChangeChecker } from "./LotDetailsChangeChecker";

/*Page Wrapper needs to take in a lot as a prop, it then must provide that prop as an available context to the actual lot details container*/

interface LotDetailsPageWrapperProps {
    initialLot: Lot,
    active: boolean,
    onLotRenamed?: (oldLotNumber: string, newLotNumber: string, updatedLot: Lot) => void,
    children: ReactNode,
}

export default function LotDetailsPageWrapper({ initialLot, active, onLotRenamed, children }: LotDetailsPageWrapperProps) {
    return (
        <>
            {active && initialLot?.summary?.lotNumber &&
                <title>{initialLot.summary.lotNumber}</title>
            }
            <Container>
                <LotDetailProvider initialLot={initialLot} onLotRenamed={onLotRenamed}>
                    <LotDetailsChangeChecker disabled={!active}>
                        {children}
                    </LotDetailsChangeChecker>
                </LotDetailProvider>
            </Container>
        </>

    );
}